import {
  PosMultiSelect,
  PosMultiSelectProps,
} from 'src/core/POS/PosMultiSelect';
import { ContentId } from 'src/utils/constants/contentId';

import {
  usePurchasePaymentMethodSelector,
  UsePurchasePaymentMethodSelectorOptions,
} from './usePurchasePaymentMethodSelector';

export type PurchasePaymentMethodMultiSelectorProps = Omit<
  PosMultiSelectProps,
  'valueOptionsContent'
> &
  UsePurchasePaymentMethodSelectorOptions;

export function PurchasePaymentMethodMultiSelector({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  placeholderText = ContentId.AllPaymentMethods,
  ...props
}: PurchasePaymentMethodMultiSelectorProps) {
  const { posSelectProps } = usePurchasePaymentMethodSelector({
    disabled,
    additionalOptions,
    additionalOptionsPosition,
  });
  return (
    <PosMultiSelect
      {...props}
      disabled={disabled}
      placeholderText={placeholderText}
      valueOptionsContent={posSelectProps.valueOptionsContent}
      searchable={posSelectProps.searchable}
      loading={posSelectProps.loading}
    />
  );
}
